import React, { useEffect, createElement } from 'react';
import { Advertorial } from './components/Advertorial';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your Pixel ID
    window.fbq('init', '1213472546398709');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'BV Biofilm Research Article',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'ReadHalfArticle', {
          article_title: 'BV Biofilm Research'
        });
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'ReadFullArticle', {
          article_title: 'BV Biofilm Research'
        });
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <div className="w-full min-h-screen bg-slate-50" data-id="element-0">
      <Advertorial data-id="element-1" />
    </div>;
}